import { render, staticRenderFns } from "./BalanceBox.vue?vue&type=template&id=6c81e0f2&"
import script from "./BalanceBox.vue?vue&type=script&lang=js&"
export * from "./BalanceBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports